import axios from '../axios';

const service = {
  fetchEmbeddableToken(reportName) {
    const report = reportName || 'default';
    const url = `reporting/context?report=${report}`;

    return axios.get(url);
  }
};

export default service;
